import {withStyles} from '@material-ui/core/styles';
import React from 'react';

import type {Theme} from '@material-ui/core/styles/createTheme';

export const styles = (theme: Theme) => ({
    '@global': {
        html: {
            backgroundColor: '#f7f7f7',
            // settings to reset html basically to control text sizing
            fontSize: '62.5%',
            height: '100%',
            '-webkit-text-size-adjust': '100%',
            '-ms-text-size-adjust': '100%',
            overflow: '-moz-scrollbars-vertical',
        },
        // it will default text sizing as 1REM = 10PX
        body: {
            padding: 0,
            position: 'relative',
            textRendering: 'optimizelegibility',
            fontSize: '1em',
            lineHeight: 1,
            fontFamily: 'Helvetica, Arial, sans-serif',
        },
        // gives most block-level element a zero margin as a baseline
        'body, table, td, ul, ol, h1, h2, h3, h4, p, img, figure': {
            margin: 0,
        },
        'ul, ol': {
            paddingLeft: 0,
        },
        // solves the cell spacing default styling on tables
        table: {
            borderCollapse: 'collapse',
            borderSpacing: 0,
        },
        // warning: this breaks all bulleted list styling, which is what li is for, just
        // so we can use it for menus and other nonsense, which is not what it is for
        li: {
            listStyle: 'none',
        },
        a: {
            backgroundColor: 'transparent',
            // default is typically underlined for links, but nobody uses that styling
            // anyway - saves you the extra effort
            '&:link, &:visited': {
                textDecoration: 'none',
            },
            '&:hover': {
                textDecoration: 'underline',
            },
            // typically text tags are given a defined color somewhere else, which will
            // then be overridden if they are children of links
            '& > span': {
                color: 'inherit',
            },
            /* SHOULD ALWAYS MATCH effects.less linkText */
            color: theme.mixins.legacyColors.brandBlue.color,
            outline: 'none',
            '&:focus, &:hover': {
                textDecoration: 'underline',
                cursor: 'pointer',
            },
        },
        img: {
            borderWidth: 0,
        },
        // displaying code: if it's a block of code nest it as <pre><code> and each
        // line will go full length with overflow-x scrolling.
        pre: {
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
        },
        code: {
            whiteSpace: 'pre-wrap',
            'pre > &': {
                whiteSpace: 'pre',
            },
        },
        button: {
            cursor: 'pointer',
            '&:disabled': {
                cursor: 'default',
            },
        },
        'article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary': {
            display: 'block',
        },
        th: {
            fontWeight: 'inherit',
        },
        dl: {
            margin: 0,
        },
        dd: {
            margin: 0,
        },
    },
});

const CssBaseline = () => {
    return <React.Fragment />;
};

export default withStyles(styles, {name: 'CssBaseline'})(CssBaseline);
